import {
  DEFAULT_FILTER_TYPES,
  defaultFilters
} from '@/compositions/filter.helpers';

export const TYPE_LIST_FILTER = 'TYPE_LIST_FILTER';
export function useTypeFilters() {
  return [defaultFilters[DEFAULT_FILTER_TYPES.STATUS]];
}
